/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cloud_Storage_Announcement_DismissInputs */

const en_cloud_storage_announcement_dismiss = /** @type {(inputs: Cloud_Storage_Announcement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss the cloud import announcement`)
};

const es_cloud_storage_announcement_dismiss = /** @type {(inputs: Cloud_Storage_Announcement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el anuncio de importación desde la nube`)
};

/**
* | output |
* | --- |
* | "Dismiss the cloud import announcement" |
*
* @param {Cloud_Storage_Announcement_DismissInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cloud_storage_announcement_dismiss = /** @type {((inputs?: Cloud_Storage_Announcement_DismissInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cloud_Storage_Announcement_DismissInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cloud_storage_announcement_dismiss(inputs)
	return en_cloud_storage_announcement_dismiss(inputs)
});